import {useMutation} from '@tanstack/react-query';
import {useDesignerSelector} from '@packages/systems/designer/flux';
import {selectSiteId} from '@packages/systems/designer/site-data';
import webflowFetch from '@packages/utilities/fetch';

type ResendResponse = {
  // How many confirmation emails actually went out.
  resent: number;
  // How many recipients were skipped because they were mailed moments ago.
  throttled: number;
  // How many requested recipients are saved and still unconfirmed.
  unconfirmed: number;
};

/**
 * Resends the confirmation email to one recipient. The server only sends to a
 * saved recipient that hasn't confirmed yet, and skips one mailed in the last
 * few minutes.
 */
export const useResendRecipientConfirmations = () => {
  const siteId = useDesignerSelector(selectSiteId);

  return useMutation<ResendResponse, Error, string>({
    mutationFn: async (email: string) => {
      const response = await webflowFetch(
        `/api/v1/site/${siteId}/form-recipient-verifications/resend`,
        {method: 'POST', body: JSON.stringify({email})}
      );
      if (!response.ok) {
        throw new Error(
          `Resending recipient confirmation emails error: ${response.statusText}`
        );
      }
      return response.json();
    },
  });
};
